module.exports = __webpack_public_path__ + "img/thumb2-tennis-blue-tennis-court-tennis-ball.f5a571a1.jpg";